/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBoxMultiple3 = createReactComponent("outline", "box-multiple-3", "IconBoxMultiple3", [["path", { "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2", "key": "svg-1" }], ["path", { "d": "M14 10a2 2 0 1 0 -2 -2", "key": "svg-2" }], ["path", { "d": "M12 12a2 2 0 1 0 2 -2", "key": "svg-3" }]]);

export { IconBoxMultiple3 as default };
//# sourceMappingURL=IconBoxMultiple3.mjs.map
